module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-image-sp-5f50890a53e4d12fced764d12499bd4b.jpg";